{
  "version": 1,
  "asset_id": "ab65a3b5-377d-401c-b77e-e838fc7f5184",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/ab65a3b5-377d-401c-b77e-e838fc7f5184/ind-healthcare-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/ab65a3b5-377d-401c-b77e-e838fc7f5184/ind-healthcare-640.avif",
  "original_filename": "ind-healthcare-640.avif",
  "size": 3745,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:01Z"
}
